export { DataStore, DataStoreClass, initSchema } from './datastore/datastore';
export { Predicates } from './predicates';
export * from './types';
//# sourceMappingURL=index.js.map